var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"break"},_vm._l((_vm.info),function(item,index){return _c('div',{key:item.type},[_c('router-link',{class:_vm.active==item.type?'active':'',attrs:{"tag":"p","to":{name:item.component,params:{type:item.type}}}},[_vm._v(_vm._s(item.title))]),_vm._v(" "),(index !== _vm.info.length-1)?_c('span',[_vm._v("/")]):_vm._e()],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c651e05","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BreadLink.vue
// module id = null
// module chunks = 